import React from "react";
import { Steps, Row, Col, Skeleton, Icon, Menu, Dropdown } from "antd";
import StepOne from "./form/stepOne/step1";
import StepTwo from "./form/stepTwo/step2";
import StepThree from "./form/stepThree/step3";
import StepFour from "./form/stepFour/step4";
import StepFive from "./form/stepFive/step5";
import StepSix from "./form/stepSix/step6";
import StepSeven from "./form/stepSeven/step7";
import StepEight from "./form/stepEight/step8";
import StepNine from "./form/stepNine/step9";
import StepTen from "./form/stepTen/step10";
import StepEleven from "./form/stepEleven/step11";
import StepTwelve from "./form/stepTwelve/step12";
import './view.css'
import { connect } from "react-redux";
import * as formActions from "./actions";
import {isMobileOnly,isMobile} from 'react-device-detect';

const { Step } = Steps;

class overviewComponent extends React.Component {
  constructor(props) {
    super(props);
    // 
    this.state = {
      maxStep: -1
    };
  }

  steps = [
    {
      title: "Personal info",
      content: <StepOne {...this.props} />,
      description: "About yourself"
    },
    {
      title: "Academic Details",
      content: <StepTwo {...this.props} />,
      description: "Add your college acadamic details"
    },
    {
      title: "Technical/Programming Skills",
      content: <StepThree {...this.props} />,
      description: "Add your relevant Technical & Programming Skills"
    },
    {
      title: "Projects",
      content: <StepFour {...this.props} />,
      description: "Add your projects "
    },
    {
      title: "Workshops Attended",
      content: <StepFive {...this.props} />,
      description: "Add your relevant Workshops attended"
    },
    {
      title: "Internships",
      content: <StepSix {...this.props} />,
      description: "Add your relevant Internships attended"
    },
    {
      title: "Conferenses Attended",
      content: <StepSeven {...this.props} />,
      description: "Add your conferenses attended."
    },
    {
      title: "Publications",
      content: <StepEight {...this.props} />,
      description: "Add your Publications and Research papers"
    },
    {
      title: "Certificates",
      content: <StepNine {...this.props} />,
      description: "Add your relevant Certifications taken"
    },
    {
      title: "Hackathons",
      content: <StepEleven {...this.props} />,
      description: "Add your relevant Hackathons attended/won"
    },
    {
      title: "Achievements",
      content: <StepTwelve {...this.props} />,
      description: "Add your relevant achievements."
    },
    {
      title: "Programming Websites",
      content: <StepTen {...this.props} />,
      description: "Add your Programming Websites Usernames"
    }
  ];

  componentWillReceiveProps(props) {
    // 

    if (this.state.maxStep < props.profile.profileCurrentStep) {
      // 
      this.setState({
        maxStep: props.profile.profileCurrentStep
      });
      if (props.profile.profileCurrentStep >= 0) {
        this.props.changeStep(
          props.profile.profileCurrentStep < 11
            ? props.profile.profileCurrentStep + 1
            : 11
        );
      }
    }
  }

  componentDidMount() {
    if (this.state.maxStep < this.props.profile.profileCurrentStep) {
      // 
      this.setState({
        maxStep: this.props.profile.profileCurrentStep
      });
      if (this.props.profile.profileCurrentStep >= 0) {
        this.props.changeStep(
          this.props.profile.profileCurrentStep < 11
            ? this.props.profile.profileCurrentStep + 1
            : 11
        );
      }
    }
  }

  onChange = current => {
    // 
    this.props.changeStep(current);
    // this.setState({ current });
  };

  getIcon = index => {
    if (index < this.state.maxStep + 1) {
      if (index === this.props.current) {
        return (
          <Icon
            type="check-circle"
            theme="filled"
            style={{
              color: "#A9BD64",
              fontSize: "30px"
            }}
          />
        );
      } else {
        return (
          <Icon
            type="check-circle"
            style={{ color: "#A9BD64", fontSize: "30px" }}
          />
        );
      }
    }
    return;
  };
  render() {
    let { current } = this.props;
    current =  current ? current : 0
    return (
      <div>
        <div className="overviewHeaderNew" >
          <h1 className="overviewHeaderH1New" >
            Welcome to Vedic.dev
          </h1>
          <p className="overviewHeaderParaNew" >
            This profile assessment is designed to measure your skills in
            responding to a range of common, on-the-job scenarios, including
            projects, internships and competitive programming. Please make sure
            all required fields are filled out correctly
          </p>
        </div>

        <Row gutter={16} style={{ margin:  isMobile ? 0 :0, padding: isMobile ? 10 :40 }}>
          <Skeleton
            active={!this.props.profile.isLoaded}
            loading={!this.props.profile.isLoaded}
          >
            {this.props.profile.isLoaded && (
              <>
                {" "}
                {isMobile ? <Col span={20} style={{padding:15,margin:22,background:'white'}}>
                <Dropdown
                overlayStyle={{"margin":"1%", "borderRadius":"5px","borderStyle":"solid","borderColor":"rebeccapurple","borderWidth":"3px"}}
                placement="topLeft"
                overlay={<Steps
                    direction="horizontal"
                    current={current}
                    onChange={this.onChange}
                  >
                    {this.steps.map((item, index) => (
                      <Step
                      style={{padding:20,borderStyle:'solid',borderBottomWidth:'1px'}}
                        key={item.title}
                        title={item.title}
                        description={item.description}
                        icon={this.getIcon(index)}
                      />
                    ))}
                  </Steps>} trigger={['click']}>
    <a className="ant-dropdown-link" href="#">
      Change Category <Icon type="down" />
    </a>
  </Dropdown>
                  
                </Col> : <Col span={7} style={{background:'white',padding:20,border:'1px dashed #e9e9e9',borderRadius:'6px'}}><Steps
                    direction="vertical"
                    current={current}
                    onChange={this.onChange}
                  >
                    {this.steps.map((item, index) => (
                      <Step
                        key={item.title}
                        title={item.title}
                        description={item.description}
                        icon={this.getIcon(index)}
                      />
                    ))}
                  </Steps></Col>}
                
                <Col xs={24} sm={24} md={24} lg={17} xl={17}>
                  <div className="steps-content">
                    {this.steps[current].content}
                  </div>
                </Col>{" "}
              </>
            )}
          </Skeleton>
        </Row>
      </div>
    );
  }
}

const mapStateToProps = state => {
  // 
  // 
  // 
  return {
    currentUser: state.firebase.auth.uid,
    profile: state.firebase.profile,
    current: state.auth.step
  };
};

const mapDispachToProps = (dispatch, props) => ({
  changeStep: formValue => {
    dispatch(formActions.changeStep(formValue, props.history));
  }
});

export default connect(
  mapStateToProps,
  mapDispachToProps
)(overviewComponent);
